/* eslint-disable @typescript-eslint/no-explicit-any */
import api, { chartCoins } from "@/src/utils";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { AreaChart } from "@tremor/react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/src/components/shad/select";
import apiRoutes from "@/src/apiRoutes";
import moment from "moment";
import { cn } from "@/lib/utils";
import { isArray } from "lodash";
const PriceChart = () => {
  const [selectedCoin, setSelectedCoin] = useState("btc");
  const [duration, setDuration] = useState("1");

  const getChart = async () => {
    const res = await api.post(apiRoutes.charts, {
      ticker: selectedCoin,
      days: Number(duration),
    });
    return res.data;
  };

  const { data } = useQuery({
    queryKey: ["get_coin_charts", selectedCoin, duration],
    queryFn: getChart,
  });

  const coins = isArray(data?.info)
    ? data?.info.map((item: any) => {
        return {
          time: moment(item[0]).format("ll"),
          price: item[1],
        };
      })
    : [];

  const times = [
    {
      label: "24h",
      value: "1",
    },
    {
      label: "7d",
      value: "7",
    },
    {
      label: "1m",
      value: "30",
    },
    // {
    //   label: '3m',
    //   value: '90'
    // },
    {
      label: "6m",
      value: "180",
    },
    {
      label: "1y",
      value: "365",
    },
  ];

  const selectedItem = chartCoins.find((item) => item.value === selectedCoin);
  // if (isLoading) return null;
  return (
    <>
      <div className="flex justify-between items-center pb-3">
        <div className="flex items-center ">
          <img
            src={selectedItem?.image}
            alt={selectedItem?.name}
            className="h-6 w-6"
          />
          <Select
            defaultValue="bitcoin"
            value={selectedCoin}
            onValueChange={setSelectedCoin}
          >
            <SelectTrigger className="border-0 dark:bg-grey-800">
              <SelectValue placeholder="" />
            </SelectTrigger>
            <SelectContent>
              {chartCoins.map((item, index) => (
                <SelectItem key={index} value={item?.value}>
                  {item?.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex gap-3">
          {times.map((item, index) => (
            <span
              onClick={() => setDuration(item?.value)}
              className={cn(
                duration === item?.value
                  ? "bg-blue-600 text-white"
                  : "text-gray-500 dark:text-gray-200",
                "px-2 py-1 text-xs  border border-gray-200 dark:border-grey-400 rounded-3xl cursor-pointer"
              )}
              key={index}
            >
              {item?.label}
            </span>
          ))}
        </div>
      </div>
      <AreaChart
        className="h-[40vh] "
        data={coins ?? []}
        index="time"
        categories={["price"]}
        colors={[
          chartCoins.find((coin) => coin.value === selectedCoin)?.color as any,
        ]}
        autoMinValue={selectedCoin !== "litecoin"}
        showAnimation
        // showXAxis={false}
        yAxisWidth={40}
        showYAxis={false}
        curveType="natural"
        showLegend={false}
        showGridLines={false}
        startEndOnly
      />
      {/* <Tabs defaultValue="7" onValueChange={setDuration}>
        <TabsList className="grid w-full grid-cols-5" >
          <TabsTrigger value="7">1W</TabsTrigger>
          <TabsTrigger value="30">1M</TabsTrigger>
          <TabsTrigger value="90">3M</TabsTrigger>
          <TabsTrigger value="180">6M</TabsTrigger>
          <TabsTrigger value="365">1Y</TabsTrigger>
        </TabsList>
      </Tabs> */}
    </>
  );
};

export default PriceChart;
